var ReceiveEmail = function () {

	var comp = $('[data-component="receive-email"]');
	var $self = this;

	this.init = function () {

		comp.each(function() {
			
			var CurrentComponent = $(this);

			$(this).find('form').validate({
				ignore: '.ignore',
				errorPlacement: function() {
				 	return true;
				},
				rules: {
					email: {
						required: true,
						email: true
						}	
				},
				submitHandler: function(form) {

			        $.ajax({
			            type: "POST",
			            url: "/umbraco/surface/Economist/Send",
			            data: JSON.stringify({ "Email": CurrentComponent.find("input[name='email']").val(), "ComponentID": CurrentComponent.data("id") }),
			            dataType: "json",
			            async: true,
			            contentType: "application/json; charset=utf-8",
			            success: function (response) {

			            	console.log("sucesso");

			            },
			            error: function (e) {

			            	console.log("error");

			            }
			        });
				}
			});

			$self.showForm($(this));
			$self.focusInput($(this));
			$self.submitEmail($(this));

		});

	}

	this.showForm = function ($comp) {

		$comp.find('.button').on('click', function() {
			$(this).hide();
			$comp.find('form').show();
			$comp.find('form label').trigger('click');
		});
	}

	this.focusInput = function ($comp) {

		$comp.find('label').on('click', function() {
			$(this).addClass('focus');
			$(this).next('input').focus();
		});

		$comp.find('input').on('focus', function() {
			$comp.find('label').text('E-mail');
		}).on('blur', function() {
			if(!$(this).val()) {
				$comp.find('label').removeClass('focus').text('Digite seu E-mail');
			}
		});
	}

	this.submitEmail = function ($comp) {

		$comp.find('form').on('submit', function() {
			if($(this).find('.error').length <1) {
				$(this).find('.fieldset, button').hide();
				$comp.find('.success').show();
			}
		});
	}

	return this.init();

}
